import React from 'react';
import { Link } from 'react-router-dom';

function Breadcrumb({ List }) {

  function buildBreadcrumb(List) {
    return (<ul>
      {
        List.map((link, index) => (
          <li key={index}>
            {link.path === "#" ? (
              <span style={{ color: '#000', cursor: 'auto' }}>{link.name}</span>
            ) : (
              <Link to={link.path}>{link.name}</Link>
            )}

          </li>
        ))}
    </ul>)
  }


  return (
    <div className="container-fluid aftrlogincontainer1 mainbgcolor">
      <div className="container mycontainer">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="breadcrumb">
              <ul>
                {buildBreadcrumb(List)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}
export default Breadcrumb
